module.exports = __webpack_public_path__ + "img/requestFull.8de51db9.svg";